import { render } from "./BudgetMonitoring.vue?vue&type=template&id=20395a81&scoped=true"
import script from "./BudgetMonitoring.vue?vue&type=script&lang=js"
export * from "./BudgetMonitoring.vue?vue&type=script&lang=js"

import "./BudgetMonitoring.vue?vue&type=style&index=0&id=20395a81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20395a81"]])

export default __exports__